import { timestamp } from 'rxjs/operators';
import { element } from 'protractor';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstantsModule } from '../../constants/constants.module';
import { LocalStorageService } from 'angular-web-storage';
import { Router } from '@angular/router';
import { isNullOrUndefined, isNull } from 'util';


@NgModule({
 declarations: [],
 imports: [
 CommonModule
 ]
})
export class UtilsSharedModule {

  getseasonlist(component: any):object[]{
    switch(component){
      case this.constants.COMPONENT.GROUNDWATER:
        return [{"key":"season1","value":"Jan- Mar","show":false,"months":"01-03"},{"key":"season2","value":"Apr - Jun","show":false,"months":"04-06"},{"key":"season3","value":"Jul - Sep","show":false,"months":"07-09"},{"key":"season4","value":"Oct - Dec","show":false,"months":"10-12"}]
        break;
      case this.constants.COMPONENT.SWATERQUALITY:
        return [{"key":"season1","value":"Jun-Sep","show":false,"months":"06-09"},{"key":"season2","value":"Oct-Jan","show":false,"months":"10-01"},{"key":"season3","value":"Feb-May","show":false,"months":"02-05"}]
        break;
    }
  }

  getseasontitle(seasontype,year, component){
    let seasonlist = this.getseasonlist(component);
    let index  = seasonlist.findIndex(data => data['key'] == seasontype)
    return seasonlist[index]['value'] +" "+year;
  }

  getSeasonType(year: number, component:any,currDate :Date= new Date()):string{
    // console.log("currDate ::",currDate);

    // let currDate = new Date();
    let currYear = currDate.getFullYear();
    let month = currDate.getMonth();
    let type: any;

    switch(component){
      case this.constants.COMPONENT.GROUNDWATER:
          type="4";
          if(year&&year == currYear)
            type = (Math.floor(month/3) + 1).toString();
          break;

      case this.constants.COMPONENT.SWATERQUALITY:
          if(year == currYear)
          {
            if(month>=5&&month<=8)
              type="1";
            else if(month>=9&&month<=11)
              type="2";
            else
              type ="-1";
          }
          else if(year == currYear-1&&month == 0)
              type="2";

          else type="3";
          break;
    }
    return type;
  }

  pattern =/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  dayNames = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  showSidemenu: boolean=false;

  defaultLocationObj = {
    locationName: this.constants.KERALA,
    locationUUID: this.constants.KERALA_UUID,
    locationType:this.constants.LOCATION_CONSTANT.STATE
  }

  constructor(private constants: ConstantsModule,private localStorage: LocalStorageService, private router: Router){}

  toggleSidemenu(){
    this.showSidemenu=!this.showSidemenu;
  }

  navigateToHome(){
    let  urlLoc = String(location), baseHref='/';
    if(urlLoc.includes('staging')){
      baseHref = '/staging';
    }
    this.router.navigateByUrl(baseHref);
  }

  getSidemenu(){
    return this.showSidemenu;
  }

  getParentTypeForGivenChildType(cType){
    let pType =null;

    if(cType == this.constants.LOCATION_CONSTANT.STATE){
      pType = this.constants.LOCATION_CONSTANT.COUNTRY;
    }else{
      let locTypeList =[];
      locTypeList =  this.localStorage.get('locationTypeListForMIS')['data'];
      let index = locTypeList.findIndex(locType => locType.toLowerCase()==cType.toLocaleLowerCase());
      if(index>-1){
        pType = locTypeList[index-1];
      }
    }

    return pType;
  }

  getChildTypeForGivenParentType(pType){
    let cType =pType;

      let locTypeList =[];
      locTypeList =  this.localStorage.get('locationTypeListForMIS')['data'];
      let index = locTypeList.findIndex(locType => locType.toLowerCase()==pType.toLocaleLowerCase());
      if(index>-1 && index != locTypeList.length-1){
        cType = locTypeList[index+1];
      }


    return cType;
  }

  getWritableObject(obj: object): object{
    if(obj == null || obj == undefined) return obj;

    let objectConfig = {};
    for(let key in obj){
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  checkDateRange(sDate: Date, eDate: Date, minDate:Date, maxDate: Date)
  {
    // if(sDate!=undefined&&sDate<minDate)
    // sDate=minDate;
    // else if(sDate!=undefined&&sDate>maxDate)
    // sDate=maxDate;

    // if(eDate!=undefined&&eDate<minDate)
    // eDate=minDate;
    // else if(eDate!=undefined&&eDate>maxDate)
    // eDate=maxDate;

    if(sDate!=undefined&&sDate<minDate)
    sDate=minDate;
    else if(sDate!=undefined&&sDate>maxDate)
    sDate=minDate;

    if(eDate!=undefined&&eDate<minDate)
    eDate=maxDate;
    else if(eDate!=undefined&&eDate>maxDate)
    eDate=maxDate;

    return {"eDate": eDate, "sDate": sDate};
  }

  isEmptyObj(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }


  capitalize(word: string): string{
    if(!word) return '';
    word = word.toLowerCase();
    return word.replace(/^\w/, c => c.toUpperCase());
  }

  pascalCase(str:string):string {
    if(!str) return '';
    let res = str.split(' ');
    let res1 ='';
    for (let  i = 0; i < res.length; i++) {
      if(i == 0)
        res1 += this.capitalize(res[i]);
      else
        res1 += (" " + this.capitalize(res[i]));
    }
   return res1;
  }

//   getComponentName(word: string): string {
//     let components = {rainfall:'Rainfall',
//     reservoir:'Reservoir',
//     RiverAuthority:'River Point Authority',
//     groundwater:'Ground Water',
//     et:'Evapotranspiration',
//     soilmoisture: 'Soil Moisture',
//     surfacewater_wq : 'Surface Water Quality',
//     groundwater_wq : 'Ground Water Quality',
// [this.constants.COMPONENT.MI_TANKS]:'Minor Irrigation Tanks'
//   }
  //   if(components[word]) return components[word];
  //   return word;
  // }

  // isValidDataQuery(options: object): boolean{
  //   if(!options || !options['parentLocName'] || !options['component'] || !this.constants.COMPONENT_FORM_FIELDS[options['component']]) return false;
  //   let valid = true;
  //   for(let index=0; index < this.constants.COMPONENT_FORM_FIELDS[options['component']].length; index++){
  //     let field = this.constants.COMPONENT_FORM_FIELDS[options['component']][index];
  //     if(Object.keys(options).indexOf(field) == -1){
  //       valid = false;
  //       break;
  //     }

  //   }
  //   return valid;
  // }

  getTableSummaryIndex(tableData: any): number{
    if(!tableData)  return -1;
    let position = -1;

    let index = tableData.findIndex(item => item['name'].toUpperCase() === "TOTAL");
    if(index>= 0){
      position = index;
    }
    return position;
  }

  getDateObjectFromModelDate(date: string): Date{
    if(!date) return undefined;
    let year = parseInt(date.substr(0, 4), 10);
    let month = parseInt(date.substr(4,2), 10);
    let day = parseInt(date.substr(6,2), 10);

    return new Date(year, (isNaN(month)?0:(month-1)), (isNaN(day)?1:day));
  }

  getDayFromDate(date: string){
   let str : string;
    str = this.getDateInFormatFromModelDate(date,'mm-dd-yyyy');
    var mydate = new Date(str);
 //   let day = this.dayNames[date.getDay()];
     let day=mydate.toString();
    day = day.slice(0,3);
    return day;
    }

    getDateInFormatFromTimeStamp(timestamp)
    {
    var date = new Date(timestamp);
    return date.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
    }

    getAddedDateFromTimeStamp(timestamp,hour)
    {
    let date =new Date(timestamp + hour*3600*1000 );
    return this.getDateInFormatFromTimeStamp(date);
    }

  getTodayAsModelDate(): string{
    let date = new Date();
    return this.getModelDateFromDate(date);
  }

  getModelDateFromDate(date: Date): string{
    if(date){
      let year = (date.getFullYear()).toString();
      let month = (((date.getMonth()+1)<10)?"0"+(date.getMonth()+1):date.getMonth()+1).toString();
      let day = ((date.getDate() < 10)?"0"+date.getDate():date.getDate()).toString();
      return year+month+day;
    } else return null;
  }

  getTimestampsFromDate(date): string {
    if (date) {
      let dt = new Date(date);

      // Set the time to 8:30 AM
      dt.setHours(8);
      dt.setMinutes(30);
      dt.setSeconds(0);
      dt.setMilliseconds(0);

      let ts = (dt.getTime()).toString()
      return ts
    }
  }

  getModelDateWithDateFormat(date: Date, format: string): string{
    if(!date) return '';

    let result = '';
    if(format == this.constants.DATEPICKER_DATE_FORMAT.YEAR)
      result = this.getModelDateFromDate(date).substr(0,4);
    else if(format == this.constants.DATEPICKER_DATE_FORMAT.MONTH)
      result = this.getModelDateFromDate(date).substr(0,6);
    else if(format == this.constants.DATEPICKER_DATE_FORMAT.HOURLY)
      result = this.getTimestampsFromDate(date)
    else
      result = this.getModelDateFromDate(date);

    return result;
  }

  getTimestampsForSDateEDate(date, type): string {
    let dt;
    if (date) {
      dt = new Date(date);
    //   if (type === 'sDate') {
    //     dt.setHours(dt.getHours() - 2);
    //     dt.setMinutes(30);
    //     dt.setSeconds(0);
    //     dt.setMilliseconds(0);
    //   } else if (type === 'eDate') {
    //     dt.setHours(dt.getHours());
    //     dt.setMinutes(30);
    //     dt.setSeconds(0);
    //     dt.setMilliseconds(0);
    //   }
    //   const ts = dt.getTime().toString();
    //   return ts;
    // }
    const minutes = dt.getMinutes();
    const baseTime = new Date(dt); // Clone

    if (minutes < 30) {
      baseTime.setHours(dt.getHours() - 1);
      baseTime.setMinutes(30);
    } else {
      baseTime.setMinutes(30);
    }

    baseTime.setSeconds(0);
    baseTime.setMilliseconds(0);

    if (type === 'sDate') {
      baseTime.setHours(baseTime.getHours() - 2);
    }

    const ts = baseTime.getTime().toString();
    return ts;
  }
  }

  replaceStringAt(original: string, index: number, replacement: string): string{
    return original.substr(0, index) + replacement+ original.substr(index + replacement.length);
  }

  validDateFormat(format: string): boolean{
    return (format && format.toLowerCase().indexOf("season") < 0);
  }

  validDateFormatGw(format: string): boolean{
    return (format && format.toString().indexOf("-") < 0);
  }

  /**
   * Logic :
   * prepare the values in all possible formats i.e MMM, mm dd etc
   * use these values to replace the format keys in the original format string
   * @param date
   * @param format
   */
  getDateInFormatFromModelDate(date: string, format: string, maxDate?: string): string{
    if(!date) return date;
    if(maxDate && maxDate < date){
      let year = parseInt(maxDate.substr(0, 4), 10);
      let month = parseInt(maxDate.substr(4,2), 10);
      let day = parseInt(maxDate.substr(6,2), 10);

      try{
        return this.getDateInFormat(year, month, day, format);
      }catch(e){
        throw e;
      }
    } else {
      let year = parseInt(date.substr(0, 4), 10);
      let month = parseInt(date.substr(4,2), 10);
      let day = parseInt(date.substr(6,2), 10);

      try{
        return this.getDateInFormat(year, month, day, format);
      }catch(e){
        throw e;
      }
    }
  }

  getDateInDefaultFormatFromModelDate(date: string){
    if(date == undefined || date.length < 4 || date.length > 8) return;
    else if(date.length == 4) return this.getDateInFormatFromModelDate(date, "YYYY")
    else if(date.length == 6) return this.getDateInFormatFromModelDate(date, "MMM-YYYY")
    else if(date.length == 8) return this.getDateInFormatFromModelDate(date, "DD-MMM-YYYY")
  }

  getDateInFormat(year: number, month: number, day: number, format: string): string{
    if(!this.validDateFormat(format))
      throw "Invalid date format";

    let monthFormat = {
      MMM : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
    let result = format;
    /**
     * this object will be used to replace the values in the key in the required format
     */
    let formattedDateObject = {
      MMM : (format.indexOf('MMM') >= 0)?monthFormat['MMM'][month-1]:'',
      mmm : (format.indexOf('mmm') >= 0)?monthFormat['MMM'][month-1]:'',
      MM : (format.indexOf('MM') >= 0)?(month < 10)?("0"+month):month:'',
      mm : (format.indexOf('mm') >= 0)?(month < 10)?("0"+month):month:'',
      yyyy : (format.indexOf('yyyy') >= 0)?year:'',
      YYYY : (format.indexOf('YYYY') >= 0)?year:'',
      yy : (format.indexOf('yy') >= 0)?year.toString().substr(2,2):'',
      YY : (format.indexOf('YY') >= 0)?year.toString().substr(2,2):'',
      dd : (format.indexOf('dd') >= 0)?(day < 10)?("0"+day):day:'',
      DD : (format.indexOf('DD') >= 0)?(day < 10)?("0"+day):day:''
    }

    for(let key in formattedDateObject){
      if(result.indexOf(key) >= 0){
        /**
         * If the model date doesn't match the required format, then try to fill whatever we can and
         * eliminate the other parameters.
         */
        if(!formattedDateObject[key]){
          result = result.replace(key, '');
          continue;
        }
        result = this.replaceStringAt(result, result.indexOf(key), formattedDateObject[key].toString())
      }
    }

    //remove the preceeding and trailing -
    result = result.replace('--', '-').replace(/^-/,'').replace(/-$/,'');
    return result;
  }
  getAddedDaysDateFromDate(date:Date,numDays) {
    if(date)
    return new Date(date.setDate(date.getDate() + numDays))
 }
 getAddedDaysCurrDateFromDate(numDays){
  return new Date(new Date().setDate(new Date().getDate() + numDays))
 }
  getDateInFormatFromDateObject(date: Date, format: string): string{
    if(!date) return '';
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let day = (date.getDate() == 0)?0:date.getDate();

    return this.getDateInFormat(year, month, day, format);;
  }

  /**
   * Convert list of model dates into the required format
   * @param dateList
   * @param format
   */
  convertListOfModelDateToFormat(dateList: Array<String>, format: string): Array<String>{
    if(!dateList) return dateList;
    let result = [];

    for(let index=0; index < dateList.length; index++){
      try{
        result.push(this.getDateInFormatFromModelDate(dateList[index].toString(), format));
      }catch(e){
        console.log(e);
        throw e;
      }
    }

    return result;
  }


  getDecimalFixed(num){
    if(!isNaN(num))
    {
      if( num === parseInt(num) ){
        return num;
        }
        else{
           num=num ? num.toFixed(2) : '-';
           return num;
        }
    }
  }

  //TODO:change last day
  getStartAndEndDatesForType(startDate:string,endDate:string,plan:string){
    if(startDate == null && startDate ==undefined){
      return " "
    }
    let data = {
      "startDate":startDate,
      "endDate":endDate
    }

    if( plan == this.constants.DATEPICKER_DATE_FORMAT.YEAR){
      data["startDate"] = data["startDate"] + "0101";
      data["endDate"] = data["endDate"] + this.getmonthyearforyearType(data["endDate"]);
    }else if( plan == this.constants.DATEPICKER_DATE_FORMAT.MONTH){
      data["startDate"] = data["startDate"] + "01";
      data["endDate"] = this.getLastDayForGivenModelDate(data['endDate']);
    }

      let y1 = data['startDate'].slice(0, 4);
      let m1 = data['startDate'].slice(4, 6);
      let d1 = data['startDate'].slice(6, 8);
      // data['startDate']= d1 + '/' + m1 + '/' + y1;
      data['startDate']=  y1 + m1  + d1;

      y1 = data['endDate'].slice(0, 4);
      m1 = data['endDate'].slice(4, 6);
      d1 = data['endDate'].slice(6, 8);
      // data['endDate']= d1 + '/' + m1 + '/' + y1;
      data['endDate']= y1 + m1  + d1;


    return data;
  }


  getLastandSecondLast(startDate:string,endDate:string,plan:string){
    let data2 = {
      "last":startDate,
      "slast":endDate
    }
    if(plan == this.constants.DATEPICKER_DATE_FORMAT.YEAR)
    {
      let y = parseInt(endDate);
      y = y-1;
      let year= y.toString();
      data2['last'] = year;
       y  = parseInt(endDate);
       y=y-2;
       year = y.toString();
      data2['slast'] = year;
    }
    if(plan == this.constants.DATEPICKER_DATE_FORMAT.MONTH || plan == this.constants.DATEPICKER_DATE_FORMAT.DAY)
    {
      let y = endDate.slice(0, 4);
      let year = parseInt(y);
      let m = endDate.slice(4, 6);
      let mon = parseInt(m);
      let p1 = this.monthNames[(mon + 12 - 2) % 12].toString();
      let month = this.monthNames[m];
      if (month == 'Jan') {
        year = year - 1;
      }
      y = year.toString().slice(2);

      data2['last'] = p1 + '-' + y ;

      let p2 = this.monthNames[(mon + 12 - 3) % 12].toString();

      if (month == 'Feb' || month == 'Jan') {
        year = year - 1;
      }

      y = year.toString().slice(2);

      data2['slast'] = p2 + '-' + y ;

    }

    return data2;

  }


  gettimestepbyformat(format){
    if(this.constants.DATEPICKER_DATE_FORMAT.YEAR === format)
     return "Yearly";
    else if(this.constants.DATEPICKER_DATE_FORMAT.MONTH == format)
     return "Monthly";
    else if(this.constants.DATEPICKER_DATE_FORMAT.DAY == format)
     return "Daily";
    else if(this.constants.DATEPICKER_DATE_FORMAT.SEASON == format)
     return "Seasonal";
    else if(this.constants.DATEPICKER_DATE_FORMAT.HOURLY == format)
     return "Hourly";
  }

  getaggregationtypedisplay(Aggtype){
    if(Aggtype === "SUM")
      return "Cumulative";
    else if(Aggtype === "AVG")
     return "Average";
    else if(Aggtype === "MIN")
     return "Minimum";
    else if(Aggtype === "MAX")
     return "Maximum";
    else if(Aggtype === "LATEST")
      return "Latest";

  }

  getmonthyearforyearType(enddate):string{
    var date = new Date();
    if(enddate == date.getFullYear()){
      let month = ((date.getMonth()+1) < 10 ? '0' + (date.getMonth()+1) : '' + (date.getMonth()+1));
      let curdate = (date.getDate() < 10 ? '0' + date.getDate(): '' + date.getDate());
      return (month +""+curdate);
    }else{
      return "1231";
    }

  }

  getLastDayForGivenModelDate(date: string,maxDate=null): string{
    if(!date) return date;
    else if(date.length == 4) {
      date = date + this.getmonthyearforyearType(date);
    }
    else if(date.length == 6){
      let currentDate = new Date();
      let year = Number.parseInt(date.substr(0,4));
      let month = Number.parseInt(date.substr(4,2));
      let lastDate = new Date(year, month, 0);
      if(year == currentDate.getFullYear() && month == currentDate.getMonth()+1)
        date = date + (currentDate.getDate() < 10 ? '0' + currentDate.getDate(): '' + currentDate.getDate());
      else
        date = date + ((lastDate.getDate() < 10)?"0"+lastDate.getDate():lastDate.getDate());
  }

   if(maxDate && date>maxDate){
    date = maxDate;
   }
   let currentDate = new Date();
  //  let cD = this.getDateObjectFromModelDate(currentDate.toString());
  // console.log("\n currentDate ", currentDate, "\n date ", date);
  //  if(date>currentDate.toString()){
  //   date = currentDate.toString();
  //  }

    return date;
  }

  getRandomColor(opacity: number): string{
    let r = (Math.floor(Math.random() * 255) + 0).toString(),
        g = (Math.floor(Math.random() * 255) + 0).toString(),
        b = (Math.floor(Math.random() * 255) + 0).toString();

    return "rgba("+r+","+g+","+b+","+opacity+")";
  }

  isChartDataEmpty(data: object): boolean{
    if(!data || !data['data'] || data['data'].length == 0 || !data['data'][0] || !data['data'][0]['data'] ||data['data'][0]['data'].length==0)  return true;
    return false;
  }

  isTableDataEmpty(data: object): boolean{
    if(!data || !data['dataSource'] || data['dataSource'].length == 0 || Object.keys(data['dataSource']).length == 0) return true;
    return false;
  }

  addNDaysToModelDate(date: number, numOfDays: number){
    if(date.toString().length < 8)  return;
    return this.getModelDateFromDate(this.addNDaysToDateObject(this.getDateObjectFromModelDate(date.toString()), numOfDays));
  }

  addNDaysToDateObject(dateObj: Date, numOfDays: number): Date{
    if(!dateObj)  return null;
    return new Date(dateObj.setTime( dateObj.getTime() + numOfDays * 86400000 ));
  }

  downloadFile(data: any, filename: string) {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // let EXCEL_TYPE2 = "application/vnd.ms-excel"
    if(!data) return;
    let blob = new Blob([data], {type: EXCEL_TYPE});
    let objectUrl = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    a.target = '_blank';
    a.click();
  }

  addEachPermanentParamsToURL(params: Object, options: Object): any {
    params = this.getWritableObject(params);
    Object.assign(params, {
      "locname": options['locname']
      , "locuuid": options['locuuid']
      , "loctype": options['loctype']
      , "view": options['view']
      , "component": options['component']
    });

    return params;
  }

  getCurMon(d) {
    let y1 = d.slice(0, 4);
    let m1 = d.slice(4, 6);
    let d1 = d.slice(6, 8);
    let date= d1 + '/' + m1 + '/' + y1;
    if (this.pattern.test(date))
    return date;
  }

  getLastMon(d) {
    let m = this.monthNames[d.getMonth()].toString();
    let p = this.monthNames[(d.getMonth() + 12 - 1) % 12].toString();
    let y = d.getFullYear();
    let y1;
    if (m == 'Jan') {
      y = y - 1;
    }
    y1 = y.toString().slice(2);
    return (p + '-' + y1);
  }


  getLastMonth(d){
    let a =  parseInt(d.slice(4,6));
    let m = this.monthNames[a-2];
    let y = parseInt(d.slice(2,4));
    if(a==1)
    {  m = 'Dec';
      y = y - 1;
    }
    let year;
    year =y.toString();
    if(y<10)
    {
      year = '0'+year;
    }
    return (m + '-' + year);
  }

  getSecondLastMonth(d){
    let a =  parseInt(d.slice(4,6));
    let m = this.monthNames[a-3];
    let y = parseInt(d.slice(2,4));
    if(a==1)
    { m = 'Nov';
      y = y - 1;
    }
    if(a==2)
    { m = 'Dec';
      y = y - 1;
    }
    let year;
    year =y.toString();
    if(y<10)
    {
      year = '0'+year;
    }
    return (m + '-' + year);

  }

  getSecLastMon() {
    const d = new Date();
    let m = this.monthNames[d.getMonth()].toString();
    let p2 = this.monthNames[(d.getMonth() + 12 - 2) % 12].toString();
    let y = d.getFullYear();
    let y1;
    if (m == 'Feb' || m == 'Jan') {
      y = y - 1;
    }
    y1 = y.toString().slice(2);
    return (p2 + '-' + y1);
  }

  getMonsoonYear(d1) {
    const d = new Date();
    var y = d.getFullYear();
    (d.getMonth() < 5) ? y = y - 1: y = y;
    return ('01/06/' + y + ' to ' + this.getCurMon(d1));
  }

  getCurrentWaterYearStartDate()
  {
    const d = new Date();
    var y = d.getFullYear();
    (d.getMonth() < 5) ? y = y - 1: y = y;
    return ('Jun 01, ' + y);

  }

  getCurrentMonsoonrYearStartDate()
  {
    const d = new Date();
    var y = d.getFullYear();
    (d.getMonth() < 5) ? y = y - 1: y = y;
    return (y+'0601');
  }

  getStartOfMonsoon(yearBack: number): Date{
    let currDate = new Date();
    currDate.setDate(currDate.getDate() - 365 * yearBack);

    let monsoonYear = currDate.getFullYear();
    if((currDate.getMonth()+1) < 6)
      monsoonYear -= 1;

    return new Date(monsoonYear, 5, 1);
  }

  setWaterYear(maxDate: Date, minDate: Date)
  {
    var defaultFormat, defaultEDate, defaultSDate;
    if(minDate&&maxDate){
      var date = new Date(maxDate.getFullYear(),5,1);
      if(date<minDate)
      date=minDate;
      if(date<=maxDate)
      {
          defaultSDate = date;
          defaultEDate = maxDate;
      }
      else
      {
          defaultEDate = maxDate;
          date = new Date(defaultEDate.getFullYear()-1,5,1)
          defaultSDate = date<minDate?minDate:date;
      }
      defaultFormat = this.getNoOfMonths(defaultSDate, defaultEDate)<=4?this.constants.DATEPICKER_DATE_FORMAT.DAY:this.constants.DATEPICKER_DATE_FORMAT.MONTH;
    }
    return {
      "format" : defaultFormat,
      "defaultSDate": defaultSDate,
      "defaultEDate": defaultEDate
    }
  }

  getNoOfMonths(sDate:Date, eDate: Date)
  {
      let noOfMonths = (eDate.getFullYear() - sDate.getFullYear())*12;
      noOfMonths-=sDate.getMonth();
      noOfMonths+=eDate.getMonth()+1;
      return noOfMonths <= 0 ? 0 : noOfMonths;
  }

  getDateDiff(date1str:string,date2str:string){
    let date1 = new Date(date1str);
    let date2 = new Date(date2str);
    let diffTime = Math.abs(date2.getTime() - date1.getTime());
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  fixedEncodeURIComponent(str) : string{
      return encodeURI(str).replace(/\(/g, "%28").replace(/\)/g, "%29");
  }

  formatParamsForBreadcrumb(component, urlParams){
    var str = Object.keys(urlParams).map(function(key){
      return encodeURIComponent(key) + '=' + encodeURIComponent(urlParams[key]);
    }).join(';');
    str = "/" + component + ";" + str;
    return str;
  }

  convertURLStringToObject(url) {
    var obj = {};
    var pairs = url.split(';');
    for (let i in pairs) {
      var split = pairs[i].split('=');
      obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
    }
    return obj;
  }

  getTSForModelDate(date: string): number{
    if(date == undefined || date.length < 8) return 0;

    let dateObj = new Date(Number.parseInt(date.substring(0,4)), Number.parseInt(date.substring(4,6))-1, Number.parseInt(date.substring(6,8)));
    return dateObj.getTime();
  }
  getNumberOfDaysBetweenTwoModelDates(startDate: string, endDate: string, format: string): number{

    let startEndDates = this.getStartAndEndDatesForType(startDate, endDate, format);
    let noOfDays = 0;
    if(startEndDates != undefined && startEndDates['startDate'] != undefined && startEndDates['endDate'] != undefined){
      let differenceInMillis = Math.abs(this.getTSForModelDate(startEndDates['endDate']) - this.getTSForModelDate(startEndDates['startDate']));
      noOfDays = differenceInMillis/this.constants.MILLIS_IN_A_DAY;
    }

    return noOfDays;
  }


  // getDownloadChartTitle(format: any, component:any, locname: any, sDate: any, eDate: any)
  // {
  //   return `${this.gettimestepbyformat(format)} ${this.getComponentName(component)} trends for ${
  //     this.capitalize(locname)} from ${this.getDateInFormatFromModelDate(this.getStartAndEndDatesForType(sDate, eDate, format)['startDate'], 'dd-mmm-yyyy')} to ${
  //     this.getDateInFormatFromModelDate(this.getStartAndEndDatesForType(sDate, eDate, format)['endDate'], 'dd-mmm-yyyy')}`;
  // }
  isEmpty(data : any):boolean{
    return data?true:false;
  }

  // getseasonlist(component: any):object[]{
  //   switch(component){
  //     case this.constants.COMPONENT.GROUNDWATER:
  //       return [{"key":"season1","value":"Jan- Mar","show":false,"months":"01-03"},{"key":"season2","value":"April - June","show":false,"months":"04-06"},{"key":"season3","value":"July - Sep","show":false,"months":"07-09"},{"key":"season4","value":"Oct - Dec","show":false,"months":"10-12"}]
  //       break;
  //     case this.constants.COMPONENT.SWATERQUALITY:
  //       return [{"key":"season1","value":"June-Sept","show":false,"months":"06-09"},{"key":"season2","value":"Oct-Jan","show":false,"months":"10-01"},{"key":"season3","value":"Feb-May","show":false,"months":"02-05"}]
  //       break;
  //   }
  // }

  // getseasontitle(seasontype,year, component){
  //   let seasonlist = this.getseasonlist(component);
  //   let index  = seasonlist.findIndex(data => data['key'] == seasontype)
  //   return seasonlist[index]['value'] +" "+year;
  // }

  // getSeasonType(year: number, component:any):string{
  //   let currDate = new Date();
  //   let currYear = currDate.getFullYear();
  //   let month = currDate.getMonth();
  //   let type: any;

  //   switch(component){
  //     case this.constants.COMPONENT.GROUNDWATER:
  //         type="4";
  //         if(year&&year == currYear)
  //           type = (Math.floor(month/3) + 1).toString();
  //         break;

  //     case this.constants.COMPONENT.SWATERQUALITY:
  //         if(year == currYear)
  //         {
  //           if(month>=5&&month<=8)
  //             type="1";
  //           else if(month>=9&&month<=11)
  //             type="2";
  //           else
  //             type ="-1";
  //         }
  //         else if(year == currYear-1&&month == 0)
  //             type="2";

  //         else type="3";
  //         break;
  //   }
  //   return type;
  // }

  getPrecisedValue(value: any, unit:any)
  {
    if(value&&typeof(value) == 'number')
    {
      if(unit&&unit=='mm')
        value = Number.isInteger(value)? value:value.toFixed(1);
        // value = value.toFixed(0);
      else if(unit&&(unit=='m'||unit=='cm'))
        value = Number.isInteger(value)? value:value.toFixed(3);
    }
    return value;
  }

  getAppropriateTimeStep(startDate: string, stopDate: string){
    if(startDate == undefined || stopDate == undefined || startDate.length < 8 || stopDate.length < 8) return "yyyyMM";
    let numOfDays = this.getNoOfDaysBetweenTwoEventGenDay(parseInt(startDate), parseInt(stopDate));
    if(numOfDays <= 31) return "yyyyMMdd";
    else if(numOfDays <= 366)  return "yyyyMM";
    else  return "yyyy";
  }

  getNoOfDaysBetweenTwoEventGenDay(startDate: number, endDate:number) {

    let count = 0;
    for (let day = startDate; day <= endDate; ) {
      count++;
      day = parseInt(this.addNDaysToModelDate(day, 1));
    }

    return count;
  }

  getNoOfDaysBetweenTwoTimeStamps(timeStamp1 : number, timeStamp2){
    let date1 = parseInt(this.getModelDateFromDate(new Date(timeStamp1)));
    let date2 = parseInt(this.getModelDateFromDate(new Date(timeStamp2)));
    return this.getNoOfDaysBetweenTwoEventGenDay(Math.min(date1,date2),Math.max(date1,date2))
  }

  updateInputDataForBreadcrumb(currentUrlParams={},inputForBreadcrumb =[]){

    if(inputForBreadcrumb.length ==0){
      return inputForBreadcrumb;
    }

    let isFilter = 'false';
    if(currentUrlParams['isFilter'] && currentUrlParams['isFilter']== 'true'){
       isFilter = 'true';
    }

    let locationObj ={
      locationName:currentUrlParams['locName'],
      locationType:currentUrlParams['pType'],
      locationUUID:currentUrlParams['locUUID']
    }

    if(isFilter == 'true'){
      let breadCrumbData = [];
      breadCrumbData.push(inputForBreadcrumb[0]);
      if(locationObj.locationType != this.constants.LOCATION_CONSTANT.STATE){
        breadCrumbData.push(locationObj);
      }
      inputForBreadcrumb = undefined;
      inputForBreadcrumb = breadCrumbData;
    }else{
      let locTypeList =[];
      locTypeList =  this.localStorage.get('locationTypeListForMIS')['data'];
      if(locTypeList.length>0){
        let lastLocation = inputForBreadcrumb[inputForBreadcrumb.length-1];
        let indexOfCurrentBreadcrumb = locTypeList.indexOf(lastLocation['locationType']);
        let indexOfUrlLocationType = locTypeList.indexOf(currentUrlParams['pType']);
        let updatedBreadcrumb =[];
        if(indexOfCurrentBreadcrumb != -1 && indexOfUrlLocationType != -1){
          if(indexOfCurrentBreadcrumb ==indexOfUrlLocationType){
           // Replace last Breadcrumb Object
            updatedBreadcrumb = inputForBreadcrumb;
            updatedBreadcrumb.pop();
            updatedBreadcrumb.push(locationObj);
          }else if(indexOfCurrentBreadcrumb > indexOfUrlLocationType){
            // Splice upto Selected Location
            let indexOfUrlLocationInBreadcrumb = inputForBreadcrumb.findIndex(obj => obj['locationUUID'] == locationObj['locationUUID']);
            if(indexOfUrlLocationInBreadcrumb !=-1){
              for(let index =0;index<=indexOfUrlLocationInBreadcrumb;index++){
                updatedBreadcrumb.push(inputForBreadcrumb[index]);
              }
            }else{
              console.log("\n Error in Updating Braedcrumb \n");
            }
          }else if(indexOfCurrentBreadcrumb < indexOfUrlLocationType){
            // Add new Location Object to Breadcrumb
            updatedBreadcrumb = inputForBreadcrumb;
            updatedBreadcrumb.push(locationObj);
          }
          inputForBreadcrumb = undefined;
          inputForBreadcrumb = updatedBreadcrumb;

        }else{
            console.log("\n Invalid Breadcrumbs \n");
        }

      }else{
        console.log("\n InValid Location Type \n");
      }
    }
    return inputForBreadcrumb;
  }

  getDateInFormatForecast(format, refTs){
    let monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if(refTs == undefined || refTs == null)
      return null;

    let d = new Date(refTs),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      let y = year.toString();

    switch(format){
      case "YYYY-MM-DD":
        return [year, month, day].join('-');

      case "DD-MM-YYYY":
        return [day, month, year].join('-');

      case "MM-dd-yyyy":
        return[month,day,year].join('-');

      case "dd-MMM-yyyy":
        month = monthShortLabel[d.getMonth()];
        return [day, month, year].join('-');

      case "dd/MM/yyyy":
        return [day, month, year].join('/');
      case "yyyyMMdd":
        return [year, month, day].join('');
      case "MMM dd":
        month = monthShortLabel[d.getMonth()];
        return [month, day].join(' ');
      case "dd MMM":
        month = monthShortLabel[d.getMonth()];
        return [day, month].join(' ');
      case 'yyyy-MM-dd':
        return [year, month, day].join('-');
      case "dd/MMM":
        month = monthShortLabel[d.getMonth()];
        return [day, month].join('/');
      // case "MMM-yy":
      //   month = monthShortLabel[d.getMonth()];
      //   year = y.substr(2,4);
      //   return [month, year].join('-');
    }
  }

  getRfMillisForDate(date, format){
    let monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if(date == undefined)
      return 0;
    let year, month, day;
    switch(format){
      case "YYYY-MM-DD":
        year = date.split('-')[0];
        month = date.split('-')[1];
        day = date.split('-')[2];
        break;
      case "dd-MMM-yyyy":
        year = date.split('-')[2];
        month = date.split('-')[1];
        day = date.split('-')[0];
        break;
      case "yyyy-MM-dd":
      year = date.split('-')[0];
      month = date.split('-')[1];
      day = date.split('-')[2];
      break;
      case "dd-MMM-yy":
      year = '20'+date.split('-')[2];
      month = monthShortLabel.indexOf(date.split('-')[1])+1;
      day = date.split('-')[0];
      break;
    }

    let date1 = new Date(year, month-1, day, 8,30,0,0);
    return date1.getTime();
  }

  getIntervalOfDay(refTs, hours, minutes, seconds){
    let date = new Date(refTs);
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    return date.getTime();
  }

  public checkUrlParams(obj: object): object {
    let objectConfig = {};

    if (obj == null || obj == undefined) return obj;

    for (let key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  getTimeStamp(date){
    let current = new Date();
    current.setDate(date.day);
    current.setMonth(date.month -1);
    current.setFullYear(date.year);
    let timestamp = current.getTime();
    return timestamp;
  }

  getShortedDataForChart(value){
    if(String(value).indexOf(".") != -1){
      var splitValue = JSON.stringify(value).split('.');
        let intPart = splitValue[0].length;
      if(intPart == 1){
        value = Number(value).toFixed(2);
        return value;
      }
      else if(intPart > 1) {
        value = Number(value).toFixed(1);
        return value;
        }
    }
    else{
      return value;
    }
  }

  getDateandTimeDashSeparatorNew(timestamp) {
    var d = new Date(timestamp);
    var year = d.getFullYear().toString();
    var month :any = d.getMonth() + 1;
    month = month.toString();
    var date = d.getDate().toString();
    var hours = d.getHours().toString();
    var minutes = d.getMinutes().toString();
    var seconds = d.getSeconds().toString();
    if (month.length < 2) month = '0' + month;
    if (date.length < 2) date = '0' + date;
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;

    var str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
    return str;
  }

   fixedToDecimal(value, decimalNumber) {
    if (isNullOrUndefined(value)) {
      return '-';
    }
    return parseFloat(value).toFixed(decimalNumber);
  }


  // updateInputDataForBreadcrumb(currentUrlParams={},inputForBreadcrumb =[]){

  //   let isFilter = 'false';
  //   if(currentUrlParams['isFilter'] && currentUrlParams['isFilter']== 'true'){
  //      isFilter = 'true';
  //   }

  //   if(inputForBreadcrumb.length>0 && isFilter == 'false'){
  //     let lastLocation = inputForBreadcrumb[inputForBreadcrumb.length-1];
  //     let indexOfBreadcrumb = this.constants.LOCATION_LEVEL[currentUrlParams['view']].indexOf(lastLocation['locationType']);
  //     let indexOfUrlLocationType = this.constants.LOCATION_LEVEL[currentUrlParams['view']].indexOf(currentUrlParams['pType']);
  //     if(indexOfBreadcrumb !=-1 && indexOfUrlLocationType != -1){
  //       let locationObj ={
  //         locationName:currentUrlParams['locName'],
  //         locationType:currentUrlParams['pType'],
  //         locationUUID:currentUrlParams['locUUID']
  //       }
  //       let copyOfBreadCrumbData = [];
  //       for(let index =0;index<inputForBreadcrumb.length;index++){
  //         copyOfBreadCrumbData.push(inputForBreadcrumb[index]);
  //       }
  //       if(indexOfUrlLocationType > indexOfBreadcrumb){
  //         copyOfBreadCrumbData.push(locationObj);
  //         inputForBreadcrumb = undefined;
  //         inputForBreadcrumb = copyOfBreadCrumbData;
  //       }
  //       else if (indexOfUrlLocationType < indexOfBreadcrumb){
  //         let indexOfUrlLocationInBreadcrumb = inputForBreadcrumb.findIndex(obj => obj['locationUUID'] == locationObj['locationUUID']);
  //         if(indexOfUrlLocationInBreadcrumb !=-1){
  //           copyOfBreadCrumbData = [];
  //           for(let index =0;index<=indexOfUrlLocationInBreadcrumb;index++){
  //             copyOfBreadCrumbData.push(inputForBreadcrumb[index]);
  //           }
  //         inputForBreadcrumb = undefined;
  //           inputForBreadcrumb = copyOfBreadCrumbData;
  //         }else{
  //           copyOfBreadCrumbData = [];
  //           for(let index =0;index<indexOfUrlLocationType;index++){
  //             copyOfBreadCrumbData.push(inputForBreadcrumb[index]);
  //           }
  //           copyOfBreadCrumbData[indexOfUrlLocationType]=locationObj;
  //           inputForBreadcrumb = undefined;
  //           inputForBreadcrumb = copyOfBreadCrumbData;
  //         }
  //       }else{
  //         copyOfBreadCrumbData[copyOfBreadCrumbData.length-1]=locationObj;
  //         inputForBreadcrumb = undefined;
  //         inputForBreadcrumb = copyOfBreadCrumbData;
  //       }
  //     }
  //   }else{
  //     let breadCrumbData = [];
  //     breadCrumbData.push(this.defaultLocationObj);
  //     if(inputForBreadcrumb.length != 0){
  //       if(currentUrlParams['pType'] != this.constants.LOCATION_CONSTANT.STATE){
  //         let locationObj ={
  //           locationName:currentUrlParams['locName'],
  //           locationType:currentUrlParams['pType'],
  //           locationUUID:currentUrlParams['locUUID']
  //         };
  //         breadCrumbData.push(locationObj);
  //       }
  //     }
  //     inputForBreadcrumb = undefined;
  //     inputForBreadcrumb = breadCrumbData;
  //   }
  //   return inputForBreadcrumb;
  // }

  getSimpleDateAndTimeStringFor12hrs(timestamp) {
    let monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
    if (isNaN(timestamp)) {
      return "--";
    } else {
      let numTimestamp = Number(timestamp);
      let currentDate = new Date(numTimestamp);
      let date = currentDate.getDate();
      let cd = date < 10 ? "0" + date : date;
      let hours = currentDate.getHours();
      let hh = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
      let minutes = currentDate.getMinutes();
      let mm = minutes < 10 ? "0" + minutes : minutes;
      let period = hours < 12 ? 'AM' : 'PM';
  
      let formattedDateTime = `${cd}-${monthShortLabel[currentDate.getMonth()]}-${currentDate.getFullYear()} ${hh}:${mm} ${period}`;
      
      return formattedDateTime;
    }
  }

 }
